import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import { Row,Col,Collapse,UncontrolledCollapse,Button } from 'reactstrap';
import EnterpriseBreadcrumb from '../../../components/EnterpriseBreadcrumb/EnterpriseBreadcrumb';
import { capitalizeFirstLetter } from '../../../utils/stringUtils';
import ReviewAlert from './../../../components/OrganizationSetup/Components/Review/ReviewAlert/ReviewAlert'
import { connect } from 'react-redux';
import * as actionCreators from '../../../modules/actions/index';


class ReviewExistingMappingManagement extends Component {
  state = { isMapGenderTypesOpened : false, mapValue:null }

  componentDidMount(){
    // console.log('11 -- ', this.props.location.state)
  }

  showPerformanceGradeCollapse = () => {
    const {performance} = this.props.location.state;
    console.log(this.props.existingMapping)
    console.log(this.props.location)
    return(
      <Row>
        <Col className="mt40" sm={{ size: 10, offset: 1 }} md={{ size: 10, offset: 1 }}>
          <div className="enterprise-review-header mb30">Performance Grades</div>
          <div className="review-mapping-row plpr20">
            <div className="review-file-txt">
              Matched Column: <span style={{fontWeight:'lighter'}}>{performance.columnName}</span>
            </div>
          </div>
          <hr style={{marginTop:'20px',marginBottom:'20px'}}/>
          <div className="review-mapping-row plpr20" id={`toggler-performance`}>
            <div className="review-file-txt">
              Matched {performance.data.length} columns
            </div>
            <div className={1 == false ? 'rotate-arrow' : 'text-center'}>
              <i className="flaticon-down-arrow review-flaticon-down-arrow cursor-pointer"></i>
            </div>
          </div>
          <UncontrolledCollapse toggler={`toggler-performance`}>
          <div className="mt30 plpr20">
          {
            performance.data.map((data,i) => {
              return(
                <div key={i} className={'review-mapped-column '.concat(i === 0 ? '' : 'mt10')}>
                  <span style={{fontWeight:'600'}}>{data.values.join(', ')}</span> 
                  <span style={{marginLeft:'5px'}}>mapped to </span>
                  <span style={{fontWeight:'600'}}>{data.reference.name}</span>
              </div>
              )
            })
          }
          </div>
          </UncontrolledCollapse>
          <hr style={{marginTop:'20px',marginBottom:'0'}}/>
        </Col>
      </Row>
    )
  }

  showOccupationsAndSeniorityCollapse = () => {
    const {type,gender,performance,seniority,occupation} = this.props.location.state;
    let matchedColumns = 0;
    if(occupation.columnName) {
      matchedColumns += 1;
    }
    if(seniority.columnName) {
      matchedColumns += 1;
    }
    if(occupation.columnName && seniority.columnName && occupation.columnName === seniority.columnName) {
      matchedColumns = 1;
    }
    return(
      <Row>
        <Col className="mt40" sm={{ size: 10, offset: 1 }} md={{ size: 10, offset: 1 }}>
        <div className="enterprise-review-header mb30">Occupations and Job Category</div>
          <div className="review-mapping-row plpr20" id={`toggler-os-column`}>
            <div className="review-file-txt">
              Matched {matchedColumns} columns
            </div>
            <div className={1 == false ? 'rotate-arrow' : 'text-center'}>
              <i className="flaticon-down-arrow review-flaticon-down-arrow cursor-pointer"></i>
            </div>
          </div>
          <UncontrolledCollapse toggler={`toggler-os-column`}>
            <div className="mt30 plpr20">
              <div className="review-mapped-column">
                Occupation Column: <span style={{fontWeight:'600'}}>{occupation.columnName}</span>
              </div>
              <div className="review-mapped-column mt10">
                Seniority Column: <span style={{fontWeight:'600'}}>{seniority.columnName}</span>
              </div>
            </div>
          </UncontrolledCollapse>
          <hr style={{marginTop:'20px',marginBottom:'20px'}}/>
          <div className="review-mapping-row plpr20" id={`toggler-os-matched`}>
            <div className="review-file-txt">
              Mapped {occupation.data.filter((o) => o.values.length > 0).length} positions to occupation categories
            </div>
            <div className={1 == false ? 'rotate-arrow' : 'text-center'}>
              <i className="flaticon-down-arrow review-flaticon-down-arrow cursor-pointer"></i>
            </div>
          </div>
          <UncontrolledCollapse toggler={`toggler-os-matched`}>
            <div className="mt30 plpr20">
            {
              occupation.data.map((data,i) => {
                // console.log('values --- ', data)
                return(
                  data.values.length > 0 ?
                  <div key={i} className={'review-mapped-column '.concat(i === 0 ? '' : 'mt10')}>
                    <span style={{fontWeight:'600'}}>{data.values.join(', ')}</span> 
                    <span style={{marginLeft:'5px'}}>mapped to </span>
                    <span style={{fontWeight:'600'}}>{data.reference.name}</span>
                  </div> : null
                )
              })
            }
            </div>
          </UncontrolledCollapse>
          <hr style={{marginTop:'20px',marginBottom:'20px'}}/>
          <div className="review-mapping-row plpr20" id={`toggler-os-matched-s`}>
            <div className="review-file-txt">
              Mapped {seniority.data.filter((o) => o.values.length > 0).length} positions to job categories
            </div>
            <div className={1 == false ? 'rotate-arrow' : 'text-center'}>
              <i className="flaticon-down-arrow review-flaticon-down-arrow cursor-pointer"></i>
            </div>
          </div>
          <UncontrolledCollapse toggler={`toggler-os-matched-s`}>
            <div className="mt30 plpr20">
            {
              seniority.data.map((data,i) => {
                return(
                  data.values.length > 0 ? 
                  <div key={i} className={'review-mapped-column '.concat(i === 0 ? '' : 'mt10')}>
                    <span style={{fontWeight:'600'}}>{data.values.join(', ')}</span> 
                    <span style={{marginLeft:'5px'}}>mapped to </span>
                    <span style={{fontWeight:'600'}}>{data.reference.name}</span>
                  </div> : null
                )
              })
            }
            </div>
          </UncontrolledCollapse>
          <hr style={{marginTop:'20px',marginBottom:'0'}}/>
        </Col>
      </Row>
    )
  }

  showSeparationCollapse = () => {
    const {type,separation} = this.props.location.state;
    return(
      <Row>
        <Col className="mt40" sm={{ size: 10, offset: 1 }} md={{ size: 10, offset: 1 }}>
          <div className="enterprise-review-header mb30">Separation Types</div>
          <div className="review-mapping-row plpr20">
            <div className="review-file-txt">
              Matched Column: <span className="review-file-name">{separation.columnName}</span>
            </div>
          </div>
          <hr style={{marginTop:'20px',marginBottom:'20px'}}/>
          <div className="review-mapping-row plpr20" id={`toggler-separation`}>
            <div className="review-file-txt">
              Matched {separation.data.length} columns
            </div>
            <div className={1 == false ? 'rotate-arrow' : 'text-center'}>
              <i className="flaticon-down-arrow review-flaticon-down-arrow cursor-pointer"></i>
            </div>
          </div>
          <UncontrolledCollapse toggler={`toggler-separation`}>
          <div className="plpr20 mt30">
            {
              separation.data.map((data,i) => {
                // console.log("adadasdd");
                // console.log(data);
                return(
                  <div key={i} className={'review-mapped-column '.concat(i === 0 ? '' : 'mt10')}>
                    <span style={{fontWeight:'600'}}>{data.values.join(', ')}</span> 
                    <span style={{marginLeft:'5px'}}>mapped to</span>
                    <span style={{fontWeight:'600'}}> {data.key}</span>
                  </div>
                )
              })
            }
          </div>
          </UncontrolledCollapse>
          <hr style={{marginTop:'20px',marginBottom:'0'}}/>
        </Col>
      </Row>
    )
  }

  showGenderTypesCollapse = () => {
    const {type,gender,performance,seniority,occupation,separation} = this.props.location.state;
    return(
      <Row>
        <Col className="mt40" sm={{ size: 10, offset: 1 }} md={{ size: 10, offset: 1 }}>
        <div className="enterprise-review-header mb30">Gender Categories</div>
          <div className="review-mapping-row plpr20">
            <div className="review-file-txt">
              Matched Column: <span className="review-file-name">{gender.columnName}</span>
            </div>
         </div>
          <hr style={{marginTop:'20px',marginBottom:'20px'}}/>
          <div className="review-mapping-row plpr20" id={`toggler-gender`}>
            <div className="review-file-txt">
              Mapped {gender.data.length} of {gender.data.length} values to gender types 
            </div>
            <div className={1 == false ? 'rotate-arrow' : 'text-center'}>
              <i className="flaticon-down-arrow review-flaticon-down-arrow cursor-pointer"></i>
            </div>
          </div>
          <UncontrolledCollapse toggler={`toggler-gender`}>
            <div className="mt30 plpr20">
              {
                gender.data.map((data,i) => {
                  // console.log("adadasdd");
                  // console.log(data);
                  return(
                    <div key={i} className={'review-mapped-column '.concat(i === 0 ? '' : 'mt10')}>
                      <span style={{fontWeight:'600'}}>{data.values.join(', ')}</span> 
                      <span style={{marginLeft:'5px'}}>mapped to</span>
                      <span style={{fontWeight:'600'}}> {data.key}</span>
                    </div>
                  )
                })
              }
            </div>
          </UncontrolledCollapse>
          <hr style={{marginTop:'20px',marginBottom:'0'}}/>
        </Col>
      </Row>
    )
  }


  showEthnicityTypesCollapse = () => {
    const {mapping} = this.props.existingMapping?this.props.existingMapping:{}
    console.log(this.props.existingMapping)
    const {ethnicity} = mapping?mapping: this.props.location.state?this.props.location.state:""
    console.log(this.props.existingMapping)
    if(ethnicity){
      return(
        <Row>
        <Col className="mt40" sm={{ size: 10, offset: 1 }} md={{ size: 10, offset: 1 }}>
          <div className="enterprise-review-header mb30">Ethnicity/Race types</div>
          <div className="review-mapping-row plpr20">
            <div className="review-file-txt">
              Matched Column: <span style={{fontWeight:'lighter'}}>{ethnicity.columnName}</span>
            </div>
          </div>
          <hr style={{marginTop:'20px',marginBottom:'20px'}}/>
          <div className="review-mapping-row plpr20" id={`toggler-performance`}>
            <div className="review-file-txt">
              Mapped {ethnicity.data.length} columns
            </div>
            <div className={1 == false ? 'rotate-arrow' : 'text-center'}>
              <i className="flaticon-down-arrow review-flaticon-down-arrow cursor-pointer"></i>
            </div>
          </div>
          <UncontrolledCollapse toggler={`toggler-performance`}>
          <div className="mt30 plpr20">
          {
            ethnicity.data.map((data,i) => {
              console.log(data)
              return(
                <div key={i} className={'review-mapped-column '.concat(i === 0 ? '' : 'mt10')}>
                  <span style={{fontWeight:'600'}}>{data.values.join(', ')}</span> 
                  <span style={{marginLeft:'5px'}}>mapped to </span>
                  <span style={{fontWeight:'600'}}>{data.key}</span>
              </div>
              )
            })
          }
          </div>
          </UncontrolledCollapse>
          <hr style={{marginTop:'20px',marginBottom:'0'}}/>
        </Col>
      </Row>
      )
    }
  }


  formatLabel = (val) => {
    if(val==='ethnicity'){
      val = 'Ethnicity/Race'
    }
    if(val==="sexualOrientation"){
      val= "Sexual Orientation"
    }
    if(val==='veteran'){
      val='Veteran Status'
    }
    return val
  }


  showMapTypesCollapse = (value) => {
    console.log(value)
    let mapValue = this.getMappingValues(value)
    value = {value} = this.props.location.state;
    console.log(value)
    console.log(mapValue)

    // if(mapValue.type==='ethnicity'){
    //   mapValue.type = 'Ethnicity/Race'
    // }
    // if(mapValue.type==="sexualOrientation"){
    //   mapValue.type= "Sexual Orientation"
    // }

    if(mapValue){
      return(
        <Row>
        <Col className="mt40" sm={{ size: 10, offset: 1 }} md={{ size: 10, offset: 1 }}>
          <div className="enterprise-review-header mb30">{this.formatLabel(mapValue.type)} </div>
          <div className="review-mapping-row plpr20">
            <div className="review-file-txt">
              Matched Column: <span style={{fontWeight:'lighter'}}>{mapValue.columnName}</span>
            </div>
          </div>
          <hr style={{marginTop:'20px',marginBottom:'20px'}}/>
          <div className="review-mapping-row plpr20" id={`toggler-performance`}>
            <div className="review-file-txt">
              Mapped {mapValue.data.length} {this.formatLabel(mapValue.type)} categories
            </div>
            <div className={1 == false ? 'rotate-arrow' : 'text-center'}>
              <i className="flaticon-down-arrow review-flaticon-down-arrow cursor-pointer"></i>
            </div>
          </div>
          <UncontrolledCollapse toggler={`toggler-performance`}>
          <div className="mt30 plpr20">
          {
            mapValue.data.map((data,i) => {
              console.log(data)
              return(
                <div key={i} className={'review-mapped-column '.concat(i === 0 ? '' : 'mt10')}>
                  <span style={{fontWeight:'600'}}>{data.values.join(', ')}</span> 
                  <span style={{marginLeft:'5px'}}>mapped to </span>
                  <span style={{fontWeight:'600'}}>{data.key}</span>
              </div>
              )
            })
          }
          </div>
          </UncontrolledCollapse>
          <hr style={{marginTop:'20px',marginBottom:'0'}}/>
        </Col>
      </Row>
      )
    }
  }


getMappingValues = (value) => {
  let type = value
  if(type!=='positions'){
    console.log(type)
    value = {value} = this.props.location.state;
    // let{data, type}= value
    console.log(value)
    // console.log(value[type], value.type===type)
  
    let obj = {
      type: value.type,
      data: value[type].data?value[type].data:[],
      columnName: value[type].columnName,
    }
    let mapValue = value.type!==undefined? obj: {columnName:"", data:[], name:'', type}
    return mapValue
  } else {
    return type
  }
 
}


  handleContinue = (value) => {
    const {seniority,occupation} = this.props.location.state;
    let mapVal = this.getMappingValues(value)
    // console.log('continue --- ',mapVal)

    // if (type==="Sexual Orientation"){
    //   type = "sexual-orientation"
    // }

    if(mapVal==='positions'){
      this.props.history.push({
        pathname : '/home/enterprise-info/map-positions',
        occupation,
        seniority
      })
    } else {

      let {data, type} = mapVal
      console.log(type)

      if (type==="Sexual Orientation" || type==="sexualOrientation"){
        type = "sexual-orientation"
      }

      this.props.history.push({
        pathname : `/home/enterprise-info/map-${type}`,
        data
      })
    }
    
    // type === 'positions' ?
    // this.props.history.push({
    //   pathname : '/home/enterprise-info/map-positions',
    //   occupation,
    //   seniority
    // }):
    // this.props.history.push({
    //   pathname : `/home/enterprise-info/map-${type}`,
    //   data
    // })

    // console.log(this.props.location.state)
    // type === 'gender' ? 
    // this.props.history.push({
    //   pathname : '/home/enterprise-info/map-gender',
    //   gender
    // })
    // : 
    // type === 'performance' ?
    // this.props.history.push({
    //   pathname : '/home/enterprise-info/map-performance',
    //   performance
    // })
    // :
    // type === 'positions' ?
    // this.props.history.push({
    //   pathname : '/home/enterprise-info/map-positions',
    //   occupation,
    //   seniority
    // })
    // :
    // type === 'separation' ? 
    // this.props.history.push({
    //   pathname : '/home/enterprise-info/map-separation',
    //   separation
    // })
    // : type === 'ethnicity' ?
    // this.props.history.push({
    //   pathname : '/home/enterprise-info/map-ethnicity',
    //   ethnicity
    // }):
    // this.props.history.push({
    //   pathname : `/home/enterprise-info/map-${type}`,
    //   ethnicity
    // })
  }

  render() { 
    console.log(this.props);
    // The mapping to review is passed in navigation state from Enterprise
    // Management; a refresh or bookmarked URL arrives without it and crashed.
    if (!this.props.location.state) {
      return <Redirect to="/home/enterprise-info" />;
    }
    let {type} = this.props.location.state;
    // console.log(this.props.location, this.pros)
  console.log(type)
    // let displayMappingCategory = capitalizeFirstLetter(type);
    let displayMappingCategory = this.formatLabel(type)
    // if(displayMappingCategory==='SexualOrientation'){
    //   displayMappingCategory = 'Sexual Orientation'
    // }
    console.log(displayMappingCategory)
    const activeText = `Map ${capitalizeFirstLetter(displayMappingCategory)}`

    return ( 
      <div className="mt50 enterprise-map-page">
        <EnterpriseBreadcrumb 
        linkText="Enterprise Management" 
        link="/home/enterprise-info" 
        activeText={activeText}
        {...this.props}/>
        <div className="map-performance-title mt30 mb10">
          {`Current ${displayMappingCategory} Mapping`}
        </div>
        <hr style={{marginBottom:'40px',marginTop:'0'}}/>
        <div className="review-instruction">
          Before you continue to edit the mapping, please review the current mapping.
        </div>
        {
          type === 'positions' ?
          this.showOccupationsAndSeniorityCollapse() :
          this.showMapTypesCollapse(type)
        } 
        
        { type === 'gender' ?
          <ReviewAlert
            alertSubHeading="Changing the gender mapping will impact all offices within the enterprise and their future data uploads."
            reviewHeading="Are you sure you want to edit the mapping?"
          /> :
          <ReviewAlert
            alertSubHeading="It will impact all offices within the enterprise and their future data uploads."
            reviewHeading="Are you sure you want to edit the mapping?"
          />
        }
        <Col sm="12" md="12" className="mt40">
          <Row>
            <Col sm={{size: 3, offset: 9}} md={{size: 3, offset: 9}}>
              <Button className="float-right continueBtn w100" onClick={()=>this.handleContinue(type)}>
                <span className="continueBtnTxt">
                  Continue
                  <span className={ 'ml10 '.concat('flaticon-next')} />
                </span>
              </Button>
            </Col>
          </Row>
        </Col>
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => {
	return {
    // saveDiversityMapping: data => dispatch(actionCreators.saveDiversityMapping(data)),
    // saveAllEthnicityMapping : (o,s) => dispatch(actionCreators.saveAllEthnicityMapping(o,s)),
    // onFileDataProcessed: (c,d,f) => dispatch(actionCreators.mapEthnicityUploadFileSuccess(c,d,f)),
    // onMatchColumn: data => dispatch(actionCreators.mapEthnicityMatchColumnSuccess(data))
	}
}
 
export default connect(mapDispatchToProps)(ReviewExistingMappingManagement);
